import { init } from './init'

export const actions = Object.assign({}, init)
